import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./Dashboard.css";

export default function Dashboard() {
  const baseURL = process.env.REACT_APP_BASE_URL;
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [counts, setCounts] = useState({ log_books: 0, hematology_logs: 0 });

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/login");
    } else {
      const payload = JSON.parse(atob(token.split(".")[1]));
      setUser({ emp_code: payload.emp_code,comp_name: payload.comp_name });
    }

    // Fetch dashboard counts
    const fetchCounts = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(`${baseURL}dashboard/counts`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setCounts(response.data);
      } catch (error) {
        console.error("Error fetching dashboard counts:", error);
      }
    };

    fetchCounts();
  }, [navigate]);

  return (
    <div className="dashboard-container">
      <div className="main-content">
        <h1>Welcome{user ? `, ${user.comp_name}` : ""}!</h1>
        <p>This is your dashboard.</p>

        <div className="card">
          <h3>Log Books</h3>
          <p>{counts.log_books}</p>
        </div>
        <div className="card">
          <h3>Hematology Logs</h3>
          <p>{counts.hematology_logs}</p>
        </div>
        <div className="card">
          <h3>Reagent Logs</h3>
          <p>{counts.reagent_inventory_logs}</p>
        </div>
      </div>
    </div>
  );
}